// extracted by mini-css-extract-plugin
export default {"imageWrapper":"jQ-z","hovered":"kQ-z","hoverImage":"lQ-z","mainImage":"mQ-z","imageNoBackground":"nQ-z","fullSizeImage":"oQ-z"};